export default function ScheduleCard({ item, lang, onClick }) {
  const date = item.crm?.followUpEndDate
    ? new Date(item.crm.followUpEndDate)
    : null;

  const time = date
    ? date.toLocaleTimeString(lang === "ar" ? "ar-SA" : "en-US", {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-";

  return (
    <button type="button"
      className={`schedule-card ${item.crm?.dateStatus || ""}`}
      onClick={onClick}
    >
      <strong>{item.onboarding?.store?.businessName || "-"}</strong>
      <span>{item.onboarding?.contact?.contactName || "-"}</span>
      <small>{item.onboarding?.contact?.mobile || "-"}</small>
      {date && <small>{time}</small>}
    </button>
  );
}
